import { render, staticRenderFns } from "./SubHeaderJiazhang03.vue?vue&type=template&id=7dc7e84c&scoped=true&"
import script from "./SubHeaderJiazhang03.vue?vue&type=script&lang=js&"
export * from "./SubHeaderJiazhang03.vue?vue&type=script&lang=js&"
import style0 from "./SubHeaderJiazhang03.vue?vue&type=style&index=0&id=7dc7e84c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc7e84c",
  null
  
)

export default component.exports